import * as angular from "angular";
import {IController} from "angular";
import {ChatFacadeService} from "../../../chat/state/chat-facade.service";
import {Subscription} from "rxjs";
import {Client as ConversationsClient, ConnectionState} from "@twilio/conversations";
import {ChatService} from "../../../chat/services/chat.service";

export class BringozChatButtonComponent implements IController {

  hasUnreadMessages?: boolean;
  unreadMessagesCount?: number;

  public conversationsClient: ConversationsClient;
  public unreadCount: number;
  public chatInitialized: boolean = false;
  public isOpen: boolean;

  private conversationsClientSubscription: Subscription;
  private selectIsOpenSubscription: Subscription;

  constructor(private $timeout,
              private chatService: ChatService,
              private chatFacadeService: ChatFacadeService,
              private $window) {
  }

  $onInit() {
    this.conversationsClientSubscription = this.chatService.conversationsClient
      .subscribe((conversationsClient: ConversationsClient) => {
        this.conversationsClient = conversationsClient;

        if (this.conversationsClient) {
          this._initConversationsEvents();
        }

        // Update Angularjs Cycle
        this.$timeout(0).then(() => {});
      });

    this.selectIsOpenSubscription = this.chatFacadeService.selectIsOpen()
      .subscribe(isOpen => {
        this.isOpen = isOpen;

        // Update Angularjs Cycle
        this.$timeout(0).then(() => {});
      });
  }


  $onDestroy() {
    this.conversationsClientSubscription.unsubscribe();
    this.selectIsOpenSubscription.unsubscribe();
  }

  onToggleChat() {
    this.chatFacadeService.setIsOpen(!this.isOpen);
  }

  private _initConversationsEvents() {
    if (this.conversationsClient) {
      this.conversationsClient.on("initialized", () => {
        this.chatInitialized = true;

        // Update Angularjs Cycle
        this.$timeout(0).then(() => {});
      });
    }
  };

}

angular
  .module('bringoz.admin.commons')
  .component('bringozChatButton', {
    bindings: {
      hasUnreadMessages: '<?',
      unreadMessagesCount: '<?'
    },
    templateUrl: 'app/modules/commons/components/bringoz-chat-button/bringoz-chat-button.html',
    controller: BringozChatButtonComponent
  });
